import { useCookieStore } from '~/store/cookieStore'

export const useActiveOrgId = () => {
  const activeOrgId = useCookieStore((s) => s.activeOrgId)
  const authToken = useCookieStore((s) => s.authToken)

  // Ignore the org id if there's no auth user. We save it after logout so that
  // we can redirect the user back to the correct org on login, but otherwise
  // should treat it as undefined if not authed.
  if (!authToken) return undefined
  return activeOrgId
}
